import { IconLoadingSpinner } from './IconLoadingSpinner'

export default IconLoadingSpinner
